<template>
  <div class="risk-remind">
    <el-dialog title="风险提醒" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="true" :modal-append-to-body=false :append-to-body="false" ref="riRemRef"
      :before-close="() => params.flag && this.$parent.toggleProductView(this.params.productInfo.code)">
      <div class="search">
        <div class="datetime">
          <!-- <label>起止时间：</label> -->
          <el-date-picker v-model="datetime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="timestamp" :append-to-body='false'>
          </el-date-picker>
        </div>
        <div class="select">
          <el-select clearable v-model="selectValue" style="width:100%" placeholder="请选择项目名称">
            <el-option v-for="item in objsList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="keywords">
          <i></i><input v-model="keywords" placeholder="请输入关键字" />
        </div>
        <div class="search-btn">
          <button @click="searchbtnClcik">搜索</button>
          <button @click="handleDownload" style="margin-left: 0.84vw;">下载</button>
        </div>
      </div>
      <div class="list">
        <div class="list-wrap">
          <el-table :data="tableData" height="90%" style="width: 100%">
            <el-table-column label="发布时间" width="150px">
              <template slot-scope="scope">
                {{ $moment(scope.row.triggertime).format('YYYY-MM-DD HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column prop="objname" label="项目名称" width="170"> </el-table-column>
            <el-table-column prop="info" label="消息内容"> </el-table-column>
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <img src="../assets/images/更多.png" @click="showMoreDetail(scope.row)" alt="" class="image">
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <more-detail ref="fxdRef" title="风险提醒详情" width="40%" :detailDialogVisible="detailDialogVisible"
      :morDetailConfig="morDetailConfig" :detailData="detailData" @changeDialogVisible="detailDialogVisible = false">
    </more-detail>

  </div>
</template>
<script>
import MoreDetail from './module/MoreDetail.vue'
import { mapState } from 'vuex'
import { handleDownload } from '@/utils/exportFile'
import { apiData } from '../api/index'
export default {
  name: 'Remind',
  props: ['params'],
  data () {
    return {
      dialogTableVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      allTableData: [],
      tableData: [],
      datetime: '',
      keywords: '',
      rootFontSize: window.rootFontSize,
      detailDialogVisible: false,
      detailData: {},
      morDetailConfig: [
        { label: '监测点名称', field: 'objname' },
        { label: '风险类型', field: 'level' },
        { label: '风险内容', field: 'info' },
        { label: '创建时间', field: 'triggertime1' },
        { label: '解除时间', field: 'cleartime1' }
      ],
      selectValue: null
    }
  },
  created () {
    this.initData()
    this.queryTxMsg()
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('home', ['objsList'])
  },
  methods: {
    // 初始化数据
    initData () {
      const currentTime = new Date().getTime()
      const startTime = currentTime - 86400000 * 60
      const endTime = currentTime
      this.datetime = [startTime, endTime]
    },
    async queryTxMsg () {
      if (!this.datetime) {
        this.$message.error('风险时间不能为空!')
        return
      }
      const company = this.$route.params.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const unitid = unit.id
      const params = {
        keyword: this.keywords,
        objid: this.selectValue ? this.selectValue : null,
        unitid: unitid,
        page: this.currentPage,
        pagesize: this.pageSize,
        stime: this.datetime[0],
        etime: this.datetime[1]
      }
      const result = await apiData.queryRiskHistory(params)
      if (result.status === 200) {
        result.data.datas.map(item => {
          item.level = item.riskname + this.numberToZhongWen(item.risklevel) + '级'
          item.triggertime1 = this.$moment(item.triggertime).format('YYYY-MM-DD HH:mm')
          item.cleartime1 = this.$moment(item.cleartime).format('YYYY-MM-DD HH:mm')
          return item
        })
        this.tableData = result.data.datas
        this.total = result.data.rows
      }
    },

    numberToZhongWen (level) {
      if (level === 1) {
        return '一'
      } else if (level === 2) {
        return '二'
      } else if (level === 3) {
        return '三'
      } else {
        return '四'
      }
    },

    searchbtnClcik () {
      this.queryTxMsg()
      this.keywords = ''
    },

    showMoreDetail (data) {
      this.detailData = data
      this.detailDialogVisible = true
      this.$nextTick(() => {
        this.$refs.fxdRef.setZindex()
      })
    },

    handleDownload () {
      const filterVal = ['triggertime1', 'objname', 'info']
      const header = ['发布时间', '项目名称', '消息内容']
      handleDownload(filterVal, this.tableData, header, '风险提醒')
    },

    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.queryTxMsg()
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.queryTxMsg()
    },
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.riRemRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  },
  components: {
    MoreDetail
  }

}
</script>
<style lang="less" scoped>
.risk-remind {
  pointer-events: none;

  /deep/ .el-dialog {
    pointer-events: auto;
  }

  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.78vw;

    .datetime {
      label {
        font-size: 1rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }

      /deep/.el-range-editor.el-input__inner {
        height: 2.5rem;
        line-height: 2.5rem;
        width: 25rem;
        background: #3C7CB8;
        border: 1px solid #5592CB;

        .el-range__icon {
          line-height: 2.5rem;
          height: 2.5rem;
        }

        .el-range-separator {
          line-height: 2.5rem;
          height: 2.5rem;
          font-size: 1rem;
          color: #FFF;
        }

        .el-range-input {
          font-size: 0.88rem;
          color: #FFF;
          background: #3C7CB8;
        }
      }
    }

    .select {
      flex: 1;
      margin: 0vw 0.52vw;
    }

    .keywords {
      background: #3C7CB8;
      margin-right: 0.52vw;
      border-radius: 0.38rem;
      border: 1px solid #5592CB;
      display: flex;
      align-items: center;

      i {
        display: inline-block;
        width: 1.13rem;
        height: 1.06rem;
        background: url("../assets/images/搜索.png") no-repeat;
        background-size: contain;
        margin: 0 0.44rem 0 1rem;
      }

      input {
        height: 2.5rem;
        flex: 1;
        border-radius: 0.38rem;
        border: 0;
        font-size: 0.88rem;
        color: #FFF;
        outline: none;
        padding: 0 1rem 0 0;
        background: #3C7CB8;
      }
    }

    .search-btn {
      display: flex;
      align-items: center;

      button {
        padding: 0.52vw 1.09vw 0.52vw;
        border: 0;
        cursor: pointer;
        font-size: 0.73vw;
        color: #ffffff;
        background: linear-gradient(204deg, #5E9CD9 0%, rgba(66, 139, 211, 0.46) 100%);
        border-radius: 0.31vw;
        border: 0.05vw solid rgba(255, 255, 255, 0.5);
        // border-image: linear-gradient(133deg, rgba(255, 255, 255, 0.5), rgba(176, 176, 176, 0), rgba(255, 255, 255, 0.5)) 1 1;
      }
    }
  }

  .list {
    flex: 1;
    position: relative;

    .list-wrap {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;

      .el-table {
        background: transparent;
        text-align: center;

        /deep/ tr {
          background: transparent;

          th {
            text-align: center;
            border: 0;
            font-size: 0.73vw;
            font-weight: 600;
            color: #FFF;
            background: #3C7CB8;
          }

          td {
            text-align: center;
            font-size: 0.73vw;
            font-weight: 400;
            color: #FFF;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url("../assets/images/打印.png") no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }

          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }

        /deep/ tr:hover td {
          background: #3C7CB8 !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0C4170;
        }

        /deep/.el-table__fixed-right-patch {
          background: #1F2C49;
          border: 0;
        }
      }

      .el-pagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        /deep/ .el-pager li {
          background: transparent;
          color: #FFF;
        }

        /deep/ .el-pager li.active {
          color: #6FBEFF;
        }

        /deep/ .el-pagination__total {
          color: #FFF;
        }

        /deep/ .btn-prev,
        .btn-next {
          background: transparent;
          color: #FFF;
        }

        /deep/ .btn-next {
          background: transparent;
          color: #FFF;
        }

        /deep/ .el-icon {
          color: #afa7a7
        }
      }

      .el-table::before {
        background: transparent;
      }

      .el-icon-more {
        color: blue;
        font-size: 0.94vw;
        cursor: pointer;
      }
    }
  }
}

/deep/.el-dialog__wrapper {
  overflow: hidden;
}

/deep/ .el-input__inner {
  height: 2.08vw;
  line-height: 2.08vw;
  background: #3C7CB8;
  border: 1px solid #5592CB;
  color: #FFF;
}

/deep/ .el-input__inner::placeholder {
  color: #FFF;
}

/deep/ input::placeholder {
  color: #FFF;
}

/deep/ .el-select__caret {
  display: flex;
  align-items: center;
}
</style>
